<template>
    <div id="app" class="wrapper">
        <div class="login cust-drivers">
            <ValidationObserver ref="observer" v-slot="{ invalid }" class="login__inner" tag="div">
                <div>
                    <img src="@/assets/images/logo-driver.png" v-bind="logoAttrs">
                </div>
                <ValidationProvider name="ID" rules="required" tag="div">
                    <input v-model="input.id" type="text" placeholder="ID">
                </ValidationProvider>
                <ValidationProvider name="password" rules="required" tag="div">
                    <input v-model="input.password" type="password" placeholder="password">
                </ValidationProvider>
                <Loader :loader="loader" />
                <div v-if="!loader">
                    <button :class="X_validatedButtonStyle" type="button" :disabled="$_setValidatedDisabled(invalid)" @click="handleLogIn()">ログイン</button>
                </div>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
    "use strict";

    import Loader from "@/components/DriversLoader.vue";
    import common from "@/mixins/common";

    export default {
        "components": {
            Loader,
        },
        "mixins": [
            common,
        ],
        data() {
            return {
                "input": {
                    "id": "",
                    "password": "",
                },
                "loader": false,
                "logoAttrs": {
                    "alt": "管クリ",
                    "title": "管クリ",
                },
            };
        },
        "methods": {
            handleLogIn() {
                this.loader = true;
                // ログイン
                common.$_axios.post(
                    `${common.$_configs.apiUrl}/drivers/login`,
                    this.input
                ).then(response => {
                    localStorage.setItem("token", response.data.access_token);
                    localStorage.setItem("expired", response.data.expired_at);
                    localStorage.setItem("role", response.data.role);
                    this.$router.push({ "name": "drivers_delivery_destinations" });
                }).catch(() => {
                    alert("ログインできませんでした。");
                    this.loader = false;
                });
            },
        },
    };
</script>
